// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../cache/node/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!../cache/node/node_modules/vue-style-loader!../cache/node/node_modules/css-loader?{"sourceMap":true}!../cache/node/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fa46839","scoped":true,"hasInlineConfig":false}!../cache/node/node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!../cache/node/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/generalUser/publishApp/components/offlinePackageTemplate.vue
// module id = 5q84
// module chunks = 0